import type { TileType } from '../../types';

import Tile from './Tile';

const Tiles = ({ tiles }: { tiles: TileType[] }) => {
  return (
    <ul
      aria-label='Highlighted prices'
      className='highlighted-prices__container grid w-full grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:col-span-2 lg:grid-cols-4'
    >
      {tiles.map(tile => (
        <li
          key={tile.id}
          id={tile.id}
        >
          <Tile tile={tile} />
        </li>
      ))}
    </ul>
  );
};

export default Tiles;
